import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { TYPE_TAG } from "../../../presentation/components/search_bar/form/tags/interface/typeTag";
import { isEqual } from "lodash";
/**
 * Zustand store hook for managing application state with persistence in sessionStorage.
 * @returns Zustand store hook for accessing and updating the application state.
 */
export const useStore = create()(persist((set, get) => ({
    app: {
        activeTag: TYPE_TAG.NONE,
        recommendedLocations: [],
    },
    locale: sessionStorage.getItem("locale") || "en",
    ipLocation: {
        ip: "",
        countryCode: "",
        currencyCode: "",
        countryName: "",
        language: "",
    },
    quicksearch: {
        data: {
            nationalityDrivingLicense: "",
        },
    },
    availability: {
        offers: [],
        filters: [],
        setOffers: (offers = []) => set((state) => ({ availability: { ...state.availability, offers } })),
    },
    setActiveTag: (tag) => set((state) => {
        if (isEqual(state.app.activeTag, tag))
            return state; // Avoid unnecessary updates if the tag is the same
        return {
            app: {
                ...state.app,
                activeTag: tag,
            },
        };
    }),
    setRecommendedLocations: (locations) => set((state) => {
        if (isEqual(state.app.recommendedLocations, locations))
            return state; // Avoid unnecessary updates if locations are the same
        return {
            app: {
                ...state.app,
                recommendedLocations: locations,
            },
        };
    }),
    setQuickSearchData: (data) => set((state) => {
        ;
        return {
            quicksearch: {
                ...state.quicksearch,
                data: { ...state.quicksearch.data, ...data },
            },
        };
    }),
    setIpLocation: (ipLocation) => set((state) => ({
        ipLocation: {
            ...state.ipLocation,
            ...ipLocation,
        },
    })),
}), {
    name: "zuntand-storage",
    storage: createJSONStorage(() => sessionStorage),
}));
useStore.subscribe((state) => {
    const LOG_SHOW_SUBSCRIBE = localStorage.getItem("ENABLE_LOGS") === "true";
    if (!LOG_SHOW_SUBSCRIBE)
        return;
    console.info("State changed:", state);
});
